import invoiceModule from '../module.js'

invoiceModule.directive('privilegeTypeDropdown', ['httpRequest', 'dictService', (httpRequest, dictService) => ({
    scope: {
        goods: '<',
        invoiceType: '<',
        privilegeTypeChange: '&',
    },
    template: `
        <div class="dropdown">
          <div class="dropdown-toggle" type="button" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true" ng-click="queryTaxRateArr()">
            <span class="et-taxrate-dropdown" title="{{goods.privilegeType}}">
                {{goods.privilegeType}}
            </span>
            <span class="caret" style="float:left;;margin-top: 10px;margin-left:2px"></span>
          </div>
          <ul class="dropdown-menu" ng-show="goods.privilegeTypeActive" style="min-width: 100px;">
            <li  ng-repeat="m in goods.privilegeTypeArr" ng-class="{active:m==goods.privilegeType}" style="text-align: left;padding-left: 5px;">
            <a href="javascript:;" ng-click="selectTaxRate(m)" style="padding-left: 5px;">{{m}}</a> </li>
          </ul>
        </div>
    `,
    replace: true,
    link (scope) {
        //获取优惠政策类型
        function getPrivilegeType () {
            return httpRequest.get_qryTaxClassInfo(scope.goods.taxMergeCode).then((res) => res.data.value)
        }
        scope.queryTaxRateArr = function queryTaxRateArr () {
            const { goods } = scope
            if ((!goods.privilegeTypeLoaded && goods.privilegeTypeArr && goods.privilegeTypeArr.length < 2) || !goods.privilegeTypeArr) {
                getPrivilegeType().then(value => {
                    goods.privilegeTypeArr = value.taxSpecialManageList
                    goods.privilegeTypeLoaded = true
                    goods.privilegeTypeActive = true
                })
            } else {
                goods.privilegeTypeActive = true
            }
        }
        scope.selectTaxRate = function selectTaxRate (privilegeType) {
            const { goods } = scope
            goods.privilegeType = privilegeType
            scope.privilegeTypeChange && scope.privilegeTypeChange(goods)
        }
    }
})])



// WEBPACK FOOTER //
// ./src/app/outputManage/fillOpenManage/invoice1/components/privilegeTypeDropdown.js